import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Login from './auth/login';
import Register from './auth/Register';

import ResetPassword from './auth/ResetPassword';
import ForgotPassword from './auth/ForgotPassword';
import ScrollToTop from '../components/ScrollTop';
import ClientDashboard from './buyer/Dashboard/Dashboard';
import NewProject from './buyer/new-project/NewProject';
import MyRequests from './buyer/my-requests/MyRequests';
import ClientProfile from './buyer/profile/ClientProfile';
import Messaging from './buyer/messaging/Messaging';
import ClientPayments from './buyer/Payments/ClientPayments';
import ArtisanDashboard from './artisan/dashboard/ArtisanDashboard';
import ProjectRequests from './artisan/projectrequests/ProjectRequests';
import ArtisanMessages from './artisan/artisan-messages/ArtisanMessages';
import ArtisanProfile from './artisan/profile/ArtisanProfile';
import MyProposals from './artisan/myproposals/MyProposals';
import ClientProjectUpdates from './buyer/updates/Updates';
import AdminDashboard from './admin/dashboard/AdminDashboard';
import ProjectManagement from './admin/Projectmanagement/ProjectManagement';
import Transactions from './admin/financialtransactions/transactions';
import Support from './admin/support/support';
import UsersManagement from './admin/usersmanagement/Users';
import ActivateAccount from './auth/ActivateAccount';
import FlaggedMessages from './admin/flaggedmessages/FlaggedMessages';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './Terms';
import NotFoundPage from './NotFound';
import ModeSelection from './buyer/ModeSelection/ModeSelection';
import ReadyProducts from './buyer/readymadeproducts/ReadyProducts/ReadyProducts';
import CartPage from './buyer/readymadeproducts/cart/Cart';
import CheckoutPage from './buyer/readymadeproducts/checkout/Checkout';
import ArtisanReadyProducts from './artisan/readymadeproductspages/readyproducts/ReadyProducts';
import ArtisanJoin from './ArtisanJoin';
import AdminArtisanApplications from './admin/applications/ArtisanApplication';
import ArtisanUpdates from './artisan/OngoingProjects-Updates/ArtisanUpdates';
import OrderHistoryPage from './buyer/readymadeproducts/orderHistory/OrderHistoryPage';
import ArtisanHelpDesk from './artisan/help-desk/HelpDesk'
import ClientHelpDesk from './buyer/help-desk/HelpDesk'
import DeleteAccount from './artisan/delete-account/DeleteAccount';


function WebRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/reset-password/:uidb64/:token/"
          element={<ResetPassword />}
        />
        <Route path="/client-dashboard" element={<ClientDashboard />} />
        <Route path="/new-project" element={<NewProject />} />
        <Route path="/projects" element={<MyRequests />} />
        <Route path="/Profile" element={<ClientProfile />} />
        <Route path="/Messages" element={<Messaging />} />
        <Route path="/payments" element={<ClientPayments />} />
        <Route path="/artisan-dashboard" element={<ArtisanDashboard />} />
        <Route path="/browse-project-requests" element={<ProjectRequests />} />
        <Route path="/messaging" element={<ArtisanMessages />} />
        <Route path="/artisan-profile" element={<ArtisanProfile />} />
        <Route path="/my-proposals" element={<MyProposals />} />
        <Route path="/my-projects" element={<ArtisanUpdates/>} />
        <Route path="/project-updates" element={<ClientProjectUpdates />} />
        <Route path="/proposals/:id" element={<ProjectRequests />} />
        <Route path="/admin-Dashboard" element={<AdminDashboard />} />
        <Route path="/users-Management" element={<UsersManagement />} />
        <Route path="/projects-Management" element={<ProjectManagement />} />
        <Route path="/financials" element={<Transactions />} />
        <Route path="/support" element={<Support />} />
        <Route
          path="/activate-account/:uidb64/:token"
          element={<ActivateAccount />}
        />
        <Route path="/flagged-messages" element={<FlaggedMessages />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="*" element={<NotFoundPage />} />

        <Route path="/mode-selection" element={<ModeSelection />} />
        <Route path="/ready-made-products" element={<ReadyProducts />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-history" element={<OrderHistoryPage />} />
        <Route path="/artisan-ready-products" element={<ArtisanReadyProducts />} />
        <Route path="/artisan-join" element={<ArtisanJoin />} />
        <Route path="/artisan-applications" element={<AdminArtisanApplications />} />
        <Route path="/artisan-help-desk" element={<ArtisanHelpDesk />} />
        <Route path="/client-help-desk" element={<ClientHelpDesk />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
    </>
  );
}

export default WebRoutes;
